import { cn } from '../../../lib/utils';

export function AdminSkeletonCards({ count = 4 }: { count?: number }) {
  return (
    <div className={cn('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4')}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="p-4 rounded-lg border border-border bg-card space-y-3 animate-pulse">
          <div className="flex justify-between items-center">
            <div className="h-3 w-20 bg-muted rounded" />
            <div className="size-8 rounded bg-muted" />
          </div>
          <div className="h-7 w-24 bg-muted rounded" />
          <div className="h-2.5 w-32 bg-muted/80 rounded" />
        </div>
      ))}
    </div>
  );
}

export function AdminSkeletonTable({ rows = 6, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="border border-border rounded-lg bg-card overflow-hidden animate-pulse">
      <div className="p-4 border-b border-border bg-muted/20 flex items-center justify-between gap-4">
        <div className="h-4 w-32 bg-muted rounded" />
        <div className="h-8 w-48 bg-muted rounded" />
      </div>
      <div className="divide-y divide-border/60">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="p-4 flex items-center gap-4">
            <div className="size-8 rounded-full bg-muted shrink-0" />
            <div className="grid gap-2 flex-1" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
              {Array.from({ length: cols }).map((_, c) => (
                <div key={c} className="h-3 bg-muted/70 rounded w-4/5" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
